/**
 * IconByName — render a ds/icons component by its string name.
 *
 * Used for icons that come from the backend or from data arrays where a
 * string name is more portable than a component reference. Falls back to
 * <Tag /> when an unknown name is supplied so nothing breaks visually.
 *
 * NEVER use this to render emoji — emoji as UI icons is banned (CLAUDE.md).
 *
 * Usage: <IconByName name="MessageSquare" className="w-4 h-4" />
 */

import React from "react";
import * as Icons from "./icons";

type IconComponent = (props: { className?: string }) => JSX.Element;

const REGISTRY: Record<string, IconComponent> = Icons as unknown as Record<string, IconComponent>;

export default function IconByName({
  name,
  className = "w-5 h-5",
}: {
  name?: string | null;
  className?: string;
}) {
  const Cmp = (name && REGISTRY[name]) || REGISTRY.Tag;
  return <Cmp className={className} />;
}
